/**
 * Utilidad para normalizar el formato de imágenes de ofertas
 * Convierte el formato antiguo (img1, img2, img3...) al nuevo formato (array)
 */

/**
 * Normaliza las imágenes de una oferta al formato array
 * @param {Object} offer - Objeto de oferta
 * @returns {Array<string>} Array de URLs de imágenes
 */
export const normalizeOfferImages = (offer) => {
  if (!offer) return [];

  // Si ya tiene el campo imagenes como array, usarlo
  if (Array.isArray(offer.imagenes)) {
    return offer.imagenes.filter(Boolean); // Filtrar valores null/undefined
  }

  // Si tiene el formato antiguo (img1, img2, img3...), convertirlo
  const images = [];
  
  // Intentar hasta img10 (puedes ajustar este número)
  for (let i = 1; i <= 10; i++) {
    const imgKey = `img${i}`;
    if (offer[imgKey]) {
      images.push(offer[imgKey]);
    }
  }

  return images;
};

/**
 * Obtiene todas las imágenes de una oferta incluyendo la portada
 * @param {Object} offer - Objeto de oferta
 * @param {boolean} includePortada - Si incluir la portada como primera imagen
 * @returns {Array<Object>} Array de objetos con url y alt
 */
export const getOfferGalleryImages = (offer, includePortada = true) => {
  if (!offer) return [];

  const images = [];

  // Agregar portada si se solicita
  if (includePortada && offer.portada) {
    images.push({
      url: offer.portada,
      alt: offer.titulo || 'Hotel',
      isPortada: true,
    });
  }

  // Obtener imágenes normalizadas
  const additionalImages = normalizeOfferImages(offer);

  // Agregar imágenes adicionales
  additionalImages.forEach((url, index) => {
    images.push({
      url,
      alt: `${offer.titulo || 'Hotel'} - Imagen ${index + 1}`,
      isPortada: false,
    });
  });

  return images;
};

/**
 * Obtiene un número limitado de imágenes para la galería
 * @param {Object} offer - Objeto de oferta
 * @param {number} maxImages - Número máximo de imágenes
 * @returns {Array<Object>} Array de objetos con url y alt
 */
export const getGalleryImages = (offer, maxImages = 5) => {
  const allImages = getOfferGalleryImages(offer, true);
  return allImages.slice(0, maxImages);
};
